import { Dispatch, SetStateAction, useEffect } from 'react';

export type UseResetSearchValueWhenShowDisabledChanges = {
  setSearchValue: Dispatch<SetStateAction<string>>;
  showDisabledTemplates: boolean;
};

export const useResetSearchValueWhenShowDisabledChanges = ({
  setSearchValue,
  showDisabledTemplates,
}: UseResetSearchValueWhenShowDisabledChanges): void => {
  useEffect(() => {
    setSearchValue('');
  }, [showDisabledTemplates, setSearchValue]);
};
